import { AUTH_ARTWORK } from 'src/layouts/auth-artwork-content';

export const AUTH_FLOW_ARTWORK = {
  resetPassword: AUTH_ARTWORK.password,
  requestSent: AUTH_ARTWORK.email,
  newPassword: AUTH_ARTWORK.password,
  confirmation: AUTH_ARTWORK.email,
  verified: AUTH_ARTWORK.verified,
  verificationError: AUTH_ARTWORK.retry,
  phoneLogin: AUTH_ARTWORK.phone,
  acceptTerms: AUTH_ARTWORK.documents,
  accountClosed: AUTH_ARTWORK.accountStatus,
  pendingDeletion: AUTH_ARTWORK.accountStatus,
  terms: AUTH_ARTWORK.documents,
  privacy: AUTH_ARTWORK.documents,
} as const;

export type AuthFlowScreen = keyof typeof AUTH_FLOW_ARTWORK;
